import { SearchInAreaButton } from './SearchInAreaButton'

export default SearchInAreaButton
